






































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import NotificationSendListBase from "./NotificationSendListBase";

	@Component
	export default class NotificationSendList extends NotificationSendListBase {
		created() {
			super.initializeRights('COR_NotificationSend_Create', 'COR_NotificationSend_Delete', 'COR_NotificationSend_Read', 'COR_NotificationSend_Update');
			super.created();
			super.setDetailName('NotificationSendDetail');
		}

		goToStudent(item: any) {
			this.goToStudentBase(item);
		}

		selectRows(items: any) {
			super.selectRows(items);
		}

		private contentModalText(): string {
			return this.contentModal;
		}

		private sendAgainOne(item: any) {
            this.sendAgainBase([item.id]);
		}

		private sendAgain(items: any) {
			this.sendAgainBase(items);
		}

		showAllertToDeleteClick(itemsSelected: any) {
			this.showAlertBeforeDeleteBase(itemsSelected);
		}

		loadFilters(value: any) { super.loadFilters(value); }
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); }
		deleteClick(elementId: any) { this.deleteClick(elementId) }
	};
